import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Button } from 'transfix-ui/components/Button'
import { INLINE_MESSAGE_VARIANTS, InlineMessage } from 'transfix-ui/components/InlineMessage'
import { Box, Link, Typography } from 'transfix-ui/core'
import formatPhone from 'utils/formatPhone'
import { CONTACT_US_PHONE_NUMBER } from '../contactPhoneNumber'
import StepButtonContainer from './StepButtonContainer'
import StepCard from './StepCard'
import { useIncompleteShipmentsQuery } from './graphql/IncompleteShipments'

interface IWelcomeStepProps {
  onCancel: () => void
}

const WelcomeStep = ({ onCancel }: IWelcomeStepProps) => {
  const { data, error, loading } = useIncompleteShipmentsQuery()
  const history = useHistory()
  const location = useLocation()

  const { currentUserIncompleteShipments } = data || {}
  const { totalCount } = currentUserIncompleteShipments || {}

  const continueClickHandler = useCallback(async () => {
    if (totalCount && totalCount > 0) {
      history.push({ pathname: '/account-deletion/step/not-eligible', search: location.search })
    } else {
      history.push({ pathname: '/account-deletion/step/verify-account', search: location.search })
    }
  }, [totalCount, history, location.search])

  return (
    <StepCard title='Delete Your Transfix Profile'>
      <Typography variant='body2'>
        Deleting your account will permanently remove all data, including load history, invoices,
        and access to carrier accounts. You will no longer be able to log into Transfix apps.
      </Typography>
      <Typography variant='body2'>
        If you may need to use Transfix in the future, we recommend keeping your account. Contact us
        at{' '}
        <Link href={`tel:${CONTACT_US_PHONE_NUMBER}`}>{formatPhone(CONTACT_US_PHONE_NUMBER)}</Link>{' '}
        for help managing your account.
      </Typography>
      <StepButtonContainer>
        <Button onClick={onCancel} color='tertiary'>
          Cancel
        </Button>
        <Button disabled={error || loading} onClick={continueClickHandler} color='primary'>
          Continue
        </Button>
        {!!error && (
          <Box paddingTop='12px'>
            <InlineMessage type={INLINE_MESSAGE_VARIANTS.ALERT} message={error?.message} />
          </Box>
        )}
      </StepButtonContainer>
    </StepCard>
  )
}

export default WelcomeStep
